__turbopack_context__.v({
  "container": "obAFnq_container",
  "graphic": "obAFnq_graphic",
  "iconDark": "obAFnq_iconDark",
  "iconLight": "obAFnq_iconLight",
  "labelDark": "obAFnq_labelDark",
  "labelLight": "obAFnq_labelLight",
  "variant--account": "obAFnq_variant--account",
});
